import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { type IProduct, type IProductSizeOption } from '@/schemas/catalog/product'

/**
 * Estado do produto aberto na PDP, compartilhado entre os componentes da página (quantidade, frete, adicionar ao
 * carrinho, seletor de tamanho) sem passar por props. Os dados de catálogo (listagem, vitrines, busca) ficam no cache
 * do React Query, não aqui. Não persiste. Só o navegador grava nesta store: no servidor ela seria compartilhada entre
 * requisições, por isso quem grava é o hook (`useCurrentProduct`), nunca o service.
 */
interface IProductState {
    /** Quantidade escolhida na PDP (mínimo 1), lida pelo frete e pelo botão de adicionar ao carrinho. */
    quantity: number
    currentProduct: IProduct | null
    productSizes: IProductSizeOption[]
    setProductQuantity: (quantity: number) => void
    setCurrentProduct: (product: IProduct, productSizes: IProductSizeOption[]) => void
    clearCurrentProduct: () => void
    resetStore: () => void
}

const initialState = {
    quantity: 1,
    currentProduct: null as IProduct | null,
    productSizes: [] as IProductSizeOption[],
}

export const useProductStore = create<IProductState>()(
    devtools(
        (set) => ({
            ...initialState,
            setProductQuantity: (quantity) =>
                set({ quantity: quantity < 1 ? 1 : quantity }, false, 'setProductQuantity'),
            setCurrentProduct: (currentProduct, productSizes) =>
                set({ currentProduct, productSizes }, false, 'setCurrentProduct'),
            clearCurrentProduct: () => set({ currentProduct: null, productSizes: [] }, false, 'clearCurrentProduct'),
            resetStore: () => set(initialState, false, 'resetStore'),
        }),
        { name: 'product-store' },
    ),
)
